import employeeTransformer from '../../transformers/employee';
import tableUtil from '../../utils/table';

import axios from 'axios';
export default (id, params) => {
  const promise = new Promise((resolve, reject) => {
    params.organization_id = id;
    axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}employees`, { params })
      .then(({ data }) => {
        if (params.page || params.per_page) {
          let dataRes = {};
          if (data.data) {
            dataRes.data = employeeTransformer.fetchCollection(data.data);
          }
          dataRes.meta = data.pagination ? { pagination: data.pagination } : tableUtil.mockupMeta(dataRes.data.length);
          resolve(dataRes);
        } else {
          resolve(employeeTransformer.fetchCollection(data.data));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
